import { render, staticRenderFns } from "./PlatformLicensing.vue?vue&type=template&id=3b7e0a15&scoped=true&"
import script from "./PlatformLicensing.vue?vue&type=script&lang=js&"
export * from "./PlatformLicensing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7e0a15",
  null
  
)

export default component.exports